var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.684 7.671a.803.803 0 0 0-1.075.076L11 12.505 6.39 7.747a.803.803 0 0 0-1.158 0A.829.829 0 0 0 5 8.32c0 .214.083.424.24.58l5.182 5.352a.802.802 0 0 0 1.156.002l5.19-5.358c.31-.32.31-.83 0-1.15l-.084-.076z"
  })));
};

export default SvgArrowDown;